import { FromSchema, ZodDate } from '@40seas/entities/common';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';
import { z } from 'zod';

export const CreditSafeVerifiedBusinessDetailsSchema = z
    .object({
        legalName: z.string().optional(),
        businessStartDate: ZodDate.optional(),
        addresses: z.array(z.string().nullish()).optional(),
        vat: z.string().optional(),
        website: z.string().optional(),
        phone: z.string().optional(),
        match: BusinessMatchSchema.nullish(),
    })
    .strict();

export class CreditSafeVerifiedBusinessDetails extends FromSchema(CreditSafeVerifiedBusinessDetailsSchema) {
    legalName?: string;
    businessStartDate?: Date;
    addresses?: string[];
    vat?: string;
    website?: string;
    phone?: string;
    match?: BusinessMatch;
}
